import React from "react"
import { Box } from "@mui/material"
import { AppCardTitle } from "@components"
import EnginePassMark from "Pages/RealTimeHistory/RealTime/Table/EnginePassMark"


export default function RealTimeTableTitle({ timeStamp, enginePass }) {
	// A client's own search: exactly as before. An engine search: its mark after the time, same line.
	const subtitle = enginePass
		? <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, whiteSpace: 'nowrap' }}>
			{timeStamp}<EnginePassMark pass={enginePass}/>
		</Box>
		: timeStamp
	return <AppCardTitle icon="magnifying-glass" title="Real Time Searches:" subtitle={subtitle}/>
}
